import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

export type Badge = 'perpl' | 'diamond' | 'platinum' | 'gold' | 'silver' | 'bronze';

const ORIGINS_TIER_ORDER: Badge[] = ['perpl', 'diamond', 'platinum', 'gold', 'silver', 'bronze'];

export const getOriginsBadge = (badges?: string[]): Badge | null => {
  if (!badges?.length) return null;
  for (const tier of ORIGINS_TIER_ORDER) {
    if (badges.includes(`origin/${tier}`)) return tier;
  }
  return null;
};

/** Origins tier label as a Lingui descriptor, e.g. "Gold Tier" / "Unranked". */
export function originsTierLabel(tier: Badge | null): MessageDescriptor {
  if (!tier) return msg({ comment: 'Origins tier when the user holds no origin badge', message: 'Unranked' });
  const name = `${tier.charAt(0).toUpperCase()}${tier.slice(1)}`;
  return msg({ comment: 'Origins tier label; {name} is the badge name, e.g. Gold', message: `${name} Tier` });
}
